import { useRef, useEffect, useState } from "react";
import { parseISO, format } from 'date-fns';
import { Link } from "react-router-dom";
import { Pagination } from "../components/ui/Pagination";
import { useApi } from "../hooks/useApi";
export default function EmailQueue() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const initialized = useRef(false);
  const { apiCall } = useApi();
  const [emailQueue, setEmailQueue] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const limit = 20; // per page
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      fetchPage(currentPage);
    }
  }, []);
  const fetchPage = async (page) => {


    setLoading(true);
    try {
      const queue = await apiCall(`fetch_email_queue`, { params: { page: page, limit: limit } });
      const emailQueueJson = await queue.json();
      setEmailQueue(emailQueueJson.items || []);
      setTotalPages(emailQueueJson.totalPages);
      setTotalRows(emailQueueJson.totalRows); // from backend
      setLoading(false);
    }
    catch (error) {
      setError("Error loading queue.");
    }


  };
  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    fetchPage(page);
  };

  if (error) return <p>Error: {error}</p>;
  return (

    <div className="p-6">
      {/* Loading overlay */}
      <div className="flex justify-between items-center mb-4">

        <h1 className="text-2xl font-bold">Log List</h1>

      </div>
      <div className="flex justify-between items-end">

        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2 w-10"></th>
              <th className="border p-2 w-50">Recipient</th>
              <th className="border p-2 w-50">Subject</th>
              <th className="border p-2">Message</th>
              <th className="border p-2  w-[180px]">Created</th>
              <th className="border p-2">Status</th>
            </tr>
          </thead>
          <tbody>

            {emailQueue.map((log, idx) => {
              const offset = ((limit) * (currentPage - 1)) + 1;
              const ascendingNumber = offset + idx;
              return (
                <tr className="border" key={log.id}>
                  <td className="border p-2">{ascendingNumber}</td>
                  <td className="border p-2">
                    <div className="flex items-center justify-between">


                      {log.recipient}


                    </div>
                  </td>
                  <td className="border p-2" >
                    {
                      log.subject
                    }
                  </td>
                  <td className="border p-2" >
                    <div className="max-h-[150px]" style={{ 'overflowY': 'auto' }} dangerouslySetInnerHTML={{ __html: log.message }} />
                  </td>
                   <td className="border p-2" >
                    {format((log.created_at), 'dd-MMM-yyyy HH:mm:ss')}
                  </td>
                  <td className="border p-2" >
                    {log.status}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>


      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={goToPage}
        loading={loading}
      />

    </div>
  );
}
